import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { FaSave, FaFileAlt, FaSignOutAlt, FaUser, FaPhone, FaCalendar, FaMapMarkerAlt, FaSearch, FaBuilding } from 'react-icons/fa';
import '../styles/UserProfileCard.css';

const UserProfileCard = ({ profile, banner }) => {
  return (
    <div className="user-profile-banner" style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
      // boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      // marginBottom: '20px',
      // padding: '20px 0',
      height: 'auto'
    }}>
      <div className="container-fluid p-0">
        <Row className="g-0">
          {/* Profile Section - Table-like Layout */}
          <Col xs={12} className="profile-section">
            <div className='d-flex flex-row align-items-stretch' style={{
              border: '1px solid #d3d3d3',
              // borderRadius: '4px',
              overflow: 'hidden'
            }}>
              {/* Profile Info Card */}
              <div className="profile-info-card" style={{
                background: '#ffffff',
                padding: '8px 12px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                minWidth: '200px',
                flex: '1'
              }}>
                <div className="profile-avatar">
                  <img src={profile.imageUrl} alt="Profile" className="profile-image" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '1px solid #d3d3d3',
                    marginRight: '8px'
                  }} />
                </div>
                <div className="profile-details" style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    color: '#000000',
                    fontWeight: '500',
                    fontSize: '0.75rem',
                    marginBottom: '2px',
                    lineHeight: '1.1'
                  }}>
                    Name: {profile.name} (OUT PATIENT)
                  </div>
                  <div style={{ color: '#000000', fontSize: '0.7rem', lineHeight: '1.1' }}>
                    {profile.phone}
                  </div>
                  <div style={{ color: '#000000', fontSize: '0.7rem', lineHeight: '1.1' }}>
                    {profile.joined}
                  </div>
                </div>
              </div>

              {/* Provider Section */}
              <div className="provider-section" style={{
                background: '#ffffff',
                borderRight: '1px solid #d3d3d3',
                borderLeft: '1px solid #d3d3d3',
                padding: '8px 12px',
                height: '60px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minWidth: '180px',
                flex: '1'
              }}>
                <div style={{
                  fontSize: '0.75rem',
                  color: '#000000',
                  marginBottom: '2px',
                  lineHeight: '1.1'
                }}>
                  ER JULY 24, 2025
                </div>
                <div style={{
                  fontSize: '0.7rem',
                  color: '#000000',
                  lineHeight: '1.1'
                }}>
                  Provider: Test Provider
                </div>
              </div>

              {/* Address Section */}
              <div className="address-section" style={{
                background: '#ffffff',
                borderRight: '1px solid #d3d3d3',
                padding: '8px 12px',
                height: '60px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minWidth: '200px',
                flex: '3'
              }}>
                <div style={{
                  fontSize: '0.8rem',
                  color: '#000000',
                  lineHeight: '1.1',
                  marginBottom: '2px'
                }}>
                  Suite 705, 863 Alva Meadows, North Ian, UT 63195
                </div>
                <div style={{
                  fontSize: '0.7rem',
                  color: '#000000',
                  lineHeight: '1.1'
                }}>
                  New York City, United States
                </div>
              </div>

              {/* Query Section */}
              <div className="query-section" style={{
                background: '#ffffff',
                borderRight: '1px solid #d3d3d3',
                padding: '8px 12px',
                height: '60px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minWidth: '150px',
                flex: '1.5'
              }}>
                <div style={{
                  fontSize: '0.75rem',
                  color: '#000000',
                  marginBottom: '2px',
                  lineHeight: '1.1'
                }}>
                  POMP Query
                </div>
                <div style={{
                  fontSize: '0.65rem',
                  color: '#000000',
                  lineHeight: '1.1'
                }}>
                  North New York City, United States
                </div>
              </div>

              {/* Action Buttons Section */}
              <div className="actions-section" style={{
                background: '#ffffff',
                height: '60px',
                display: 'flex',
                flexDirection: 'row',
                minWidth: '240px',
                flex: '1.2'
              }}>
                <div className="action-button save-btn" >
                  <FaSave size={18} style={{ color: '#000000' }} />
                  <span style={{
                    fontSize: '0.6rem',
                    fontWeight: '500',
                    color: '#000000',
                    lineHeight: '1'
                  }}>Save</span>
                </div>
                <div className="action-button reports-btn" >
                  <FaFileAlt size={18} style={{ color: '#000000' }} />
                  <span style={{
                    fontSize: '0.6rem',
                    fontWeight: '500',
                    color: '#000000',
                    lineHeight: '1'
                  }}>Reports</span>
                </div>
                <div className="action-button logout-btn" >
                  <FaSignOutAlt size={18} style={{ color: '#000000' }} />
                  <span style={{
                    fontSize: '0.6rem',
                    fontWeight: '500',
                    color: '#000000',
                    lineHeight: '1'
                  }}>Logout</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Banner Information Row - Separate Row Below */}
      <div className="container-fluid p-0">
        <div className="col-12 p-0 mb-2">
          <Card.Body className="d-flex align-items-center justify-content-center banner-card-information" >
            <div className="d-flex justify-content-center w-100">
              <span className="px-4">{banner.status}</span>
              <span className="px-4"> {banner.result}</span>
              <span className="px-4"> {banner.lastUpdated}</span>
            </div>
          </Card.Body>
        </div>

      </div>
    </div>
  );
};

export default UserProfileCard;
